/**
 * Persist Create Media Plan form snapshots to the planning service (pre-submit
 * draft workspace).
 *
 * Endpoint: `/planning-api/v1/planning-drafts/create-draft/{id}` (planning service).
 * vite.config.ts proxies /planning-api → http://planning:3002.
 *
 * PR-Sec fix: apiService.put prepends `/core-api` (its configured baseURL), which
 * would route to the wrong service. Use apiService.api directly with
 * `{ baseURL: '' }` (same pattern as planningService.ts for mediaplan CRUD).
 */

import { apiService } from './api';

export const planningDraftService = {
  async putCreateDraft(entityId: string, formSnapshot: Record<string, unknown>): Promise<void> {
    await apiService.api.put(
      `/planning-api/v1/planning-drafts/create-draft/${entityId}`,
      { form_snapshot: formSnapshot },
      { baseURL: '' }
    );
  },
};
